<template>
  <span class="d-inline-block ratio ratio-1x1 overflow-hidden" :class="container">
    <svg class="w-100 h-100" :class="color" :style="{ color: color }"><use :href="`${sprite}#${name}`"/></svg>
    <slot name="tooltip"/>
  </span>
</template>
<script>
export default {
  name: 'Icon',
  props: {
    sprite: {
      default: '/sprite.svg'
    },
    name: {
      required: true
    },
    container: {
      required: true,
      default: 'i-0',
      validator(value) {
        //TODO when vue allows validation across multiple props, enhance this to enforce i-0 needing width/height and pre-defined styles not passing it
        return ['i-0', 'i-8', 'i-12', 'i-16', 'i-24', 'i-32', 'i-40','i-48', 'i-60'].includes(value)
      }
    },
    color: {},
    width: {
      default: '100%'
    },
    height: {
      default: '100%'
    }
  }
}
</script>
<style scoped lang="scss">
span {
  &.i-0 {
    width: v-bind(width);
    height: v-bind(height);
  }

  @each $c in (8, 12, 16, 24, 32, 40 ,48, 60) {
    &.i-#{$c} {
      width: #{$c}px;
    }
  }
}
</style>